module.exports = __webpack_public_path__ + "static/media/Temuco.60e54259.png";